import { createAction } from 'redux-actions'

export const quoteEmailData = createAction('QUOTE/SET_QUOTE_EMAIL_DATA')
